import Component from 'D:/小小程序员/项目/medical-management/OPO-uni/components/AreaSelect/index.vue'
wx.createComponent(Component)